import { SETTING_TEXTS_PT } from './setting-texts.js';
export const WEB_TEXTS = {
    'pt-BR': {
        ...SETTING_TEXTS_PT,
        Casual: 'Casual',
        Ranked: 'Ranqueado',
        'Casual: power-ups on, guests welcome, does not count for the ranking.': 'Casual: com power-ups, aberto a convidados, não conta para o ranking.',
        'Ranked: no power-ups, account required, counts for the ranking.': 'Ranqueado: sem power-ups, exige conta, conta para o ranking.',
        'Play now': 'Jogar agora',
        'Play now (experimental)': 'Jogar agora (experimental)',
        'Auto move': 'Andar sozinho',
        'Auto fire': 'Tiro automático',
        'Play as guest': 'Jogar como convidado',
        'Sign in': 'Entrar',
        'Sign out': 'Sair',
        'Create account': 'Criar conta',
        Username: 'Nome de usuário',
        Password: 'Senha',
        'E-mail (used only to recover your password)': 'E-mail (usado só para recuperar a senha)',
        'Forgot your password?': 'Esqueceu a senha?',
        'Username or e-mail': 'Nome de usuário ou e-mail',
        'Send recovery link': 'Enviar link de recuperação',
        'If the account exists, a recovery link was sent to its e-mail. The link expires in 30 minutes.': 'Se a conta existir, um link de recuperação foi enviado ao e-mail dela. O link expira em 30 minutos.',
        'New password': 'Nova senha',
        'Invalid username or password.': 'Nome de usuário ou senha inválidos.',
        'Too many attempts. Wait $1 seconds and try again.': 'Muitas tentativas. Aguarde $1 segundos e tente de novo.',
        'This username is already taken.': 'Este nome de usuário já está em uso.',
        'The password must have at least 8 characters.': 'A senha precisa ter pelo menos 8 caracteres.',
        'This password is too common. Choose another.': 'Essa senha é comum demais. Escolha outra.',
        // opções gráficas avançadas (OG-070)
        Scrolling: 'Rolagem',
        'Less transparency effects': 'Menos efeitos de transparência',
        'Disappeared players on minimap': 'Jogadores sumidos no minimapa',
        'fade out': 'esmaecer',
        'hide early': 'esconder cedo',
        'hide late': 'esconder tarde',
        'Highlight returned and dropped flags': 'Destacar bandeiras devolvidas e largadas',
        'Make flags extra-visible': 'Bandeiras mais visíveis',
        'multi-roomed': 'com várias salas',
        'Show flag disappearance positions': 'Mostrar onde as bandeiras sumiram',
        'Highlight self after spawn': 'Destacar a si mesmo ao nascer',
        'Markers for nearby players and flags in game': 'Marcadores de jogadores e bandeiras próximos',
        'single-roomed': 'com uma sala',
        'Box visible area on map in game': 'Marcar a área visível no minimapa',
        'Let view follow over map border': 'Vista passa da borda do mapa',
        'when all rooms aren\'t shown': 'quando nem todas as salas aparecem',
        'if the border has doorways': 'se a borda tem passagens',
        'Allow parts of map to repeat on screen': 'Permitir partes do mapa repetidas na tela',
        'Highlight maps not in the game': 'Destacar mapas que não são do jogo',
        'Stats screen alpha': 'Opacidade das telas de estatísticas',
        'Map info mode': 'Modo de informação do mapa',
        'Stay dead when in a menu at round start': 'Ficar morto se estiver num menu no início da partida',
        'Underline players with an account': 'Sublinhar jogadores com conta',
        'Background theme': 'Tema do fundo',
        'Prefer main theme background': 'Preferir o fundo do tema principal',
        '<no background>': '<sem fundo>',
        // termos, privacidade e sobre (OG-107)
        'Operator contact: $1': 'Contato do responsável: $1',
        'to be defined by the operator': 'a definir pelo responsável',
        'Terms of use': 'Termos de uso',
        'Privacy policy': 'Política de privacidade',
        'Version $1': 'Versão $1',
        'What we keep, why and for how long': 'O que guardamos, por quê e por quanto tempo',
        Data: 'Dado',
        Why: 'Por quê',
        'For how long': 'Por quanto tempo',
        'About Outgun Web': 'Sobre o Outgun Web',
        'Outgun is a 2D multiplayer capture-the-flag game from 2002-2011, loved by Finnish and Brazilian players. Outgun Web brings version 1.0.3 to the browser: same rules, physics and maps, nothing to install.': 'O Outgun é um jogo multiplayer 2D de captura de bandeira (2002-2011), querido por jogadores finlandeses e brasileiros. O Outgun Web leva a versão 1.0.3 para o navegador: mesmas regras, física e mapas, sem instalar nada.',
        'How to play': 'Como jogar',
        'Arrows move, Ctrl shoots, Shift runs; take the enemy flag to your base. Press F1 in game for the scoreboard and Esc for the menu. All keys can be changed in Options > Controls.': 'Setas movem, Ctrl atira, Shift corre; leve a bandeira inimiga até a sua base. No jogo, F1 mostra o placar e Esc abre o menu. Todas as teclas podem ser trocadas em Opções > Controles.',
        'Free software': 'Software livre',
        'Outgun and Outgun Web are free software under the GNU GPL (version 2 or later).': 'O Outgun e o Outgun Web são software livre sob a GNU GPL (versão 2 ou posterior).',
        About: 'Sobre',
        Terms: 'Termos',
        Privacy: 'Privacidade',
        'Accept the terms of use and the privacy policy to create the account.': 'Aceite os termos de uso e a política de privacidade para criar a conta.',
        'I accept the terms of use and the privacy policy': 'Aceito os termos de uso e a política de privacidade',
        'Read the terms of use': 'Ler os termos de uso',
        'Read the privacy policy': 'Ler a política de privacidade',
        Yes: 'Sim',
        No: 'Não',
        // telemetria de rede (OG-108)
        Network: 'Rede',
        '$1 days': '$1 dias',
        'No reports yet.': 'Nenhum resumo ainda.',
        Region: 'Região',
        Minutes: 'Minutos',
        'Ping p50 / p95 (ms)': 'Ping p50 / p95 (ms)',
        'Control delay p50 (ms)': 'Atraso dos controles p50 (ms)',
        'Corrections/min': 'Correções/min',
        'fps p5': 'fps p5',
        'Frame drops': 'Quedas de frames',
        'Send anonymous network statistics': 'Enviar estatísticas anônimas da rede',
        'Show input latency': 'Mostrar latência das teclas',
        'Diagonal tolerance': 'Tolerância de diagonal',
        'monitor refresh rate': 'taxa do monitor',
        'automatic (240)': 'automático (240)',
        'Reopen the game to unlock the FPS.': 'Reabra o jogo para liberar o FPS.',
        'Monitor resolution': 'Resolução do monitor',
        system: 'do sistema',
        'Full screen only (F11). Alt+Tab and leaving the game bring back the normal resolution.': 'Só em tela cheia (F11). Alt+Tab e sair do jogo voltam à resolução normal.',
        'The launch option --resolution=$1 is in use; this choice applies without it.': 'A opção de inicialização --resolution=$1 está valendo; esta escolha vale sem ela.',
        'Apply resolution': 'Aplicar resolução',
        'The screen may go black for a moment.': 'A tela pode ficar preta por um instante.',
        'Browsers draw at most once per monitor refresh. The desktop client (Steam) can go above it.': 'O navegador desenha no máximo uma vez por atualização do monitor. O cliente desktop (Steam) passa disso.',
        'Keys pressed or released this close together count as together: the gun does not turn on the way. Movement never waits.': 'Teclas apertadas ou soltas com essa diferença contam como juntas: a arma não vira no meio do caminho. O movimento nunca espera.',
        // beta fechado (OG-106)
        '$1 invites created.': '$1 convites criados.',
        Bug: 'Bug',
        'Create invites': 'Criar convites',
        'Days valid (empty = no end)': 'Dias de validade (vazio = sem fim)',
        'Does it feel like the original Outgun? (1 = not at all, 5 = just like it)': 'A sensação de jogo é a do Outgun original? (1 = nada, 5 = igualzinha)',
        'Download CSV': 'Baixar CSV',
        Feedback: 'Feedback',
        Fidelity: 'Fidelidade',
        'Fidelity, everyone': 'Fidelidade, todos',
        'Fidelity, veterans (goal: 20 with average 4+)': 'Fidelidade, veteranos (meta: 20 com média 4+)',
        'Give a rating or write something.': 'Dê uma nota ou escreva algo.',
        'How many': 'Quantos',
        'I played the original Outgun': 'Joguei o Outgun original',
        'Invite code': 'Código de convite',
        'Invite link': 'Link do convite',
        Invites: 'Convites',
        Note: 'Observação',
        'Open critical bugs: $1': 'Bugs críticos abertos: $1',
        Other: 'Outro',
        Overall: 'Geral',
        'Overall rating': 'Nota geral',
        Praise: 'Elogio',
        'Send feedback': 'Enviar feedback',
        Status: 'Situação',
        Suggestion: 'Sugestão',
        'Tell us more (what happened, where, how to reproduce)': 'Conte mais (o que aconteceu, onde, como repetir)',
        Text: 'Texto',
        'Thank you! Your feedback was sent.': 'Obrigado! Seu feedback foi enviado.',
        'The closed beta needs an invite code.': 'O beta fechado precisa de um código de convite.',
        'The server is not in closed beta (BETA=1): invites are not required to sign up.': 'O servidor não está em beta fechado (BETA=1): o cadastro não exige convite.',
        'This invite code is invalid, already used or expired.': 'Este convite é inválido, já foi usado ou venceu.',
        Type: 'Tipo',
        'Used by': 'Usado por',
        Uses: 'Usos',
        'Uses each': 'Usos de cada',
        average: 'média',
        confirmed: 'confirmado',
        critical: 'crítico',
        dismissed: 'descartado',
        new: 'novo',
        resolved: 'resolvido',
        revoked: 'revogado',
        'The closed beta needs an account: sign in, or create one with your invite.': 'O beta fechado exige conta: entre, ou crie uma com o seu convite.',
        // painel admin (OG-087)
        '$1 is now $2.': '$1 agora é $2.',
        Action: 'Ação',
        'Audit log': 'Auditoria',
        Ban: 'Banir',
        'Ban created.': 'Ban criado.',
        'Ban minutes': 'Minutos de ban',
        'Ban revoked.': 'Ban revogado.',
        Bans: 'Bans',
        'Built-in presets change only with a new release; the Ranked preset only by decision of the product owner.': 'Os presets do jogo só mudam com uma versão nova; o Ranked, só por decisão do dono do produto.',
        By: 'Por',
        '(server default)': '(padrão do servidor)',
        'Add to Casual': 'Pôr na Casual',
        'Add to Ranked': 'Pôr no Ranqueado',
        '$1 of $2 maps checked.': '$1 de $2 mapas marcados.',
        'Changes apply from the next map change.': 'As mudanças valem a partir da próxima troca de mapa.',
        'Check all': 'Marcar todos',
        'Uncheck all': 'Desmarcar todos',
        'Undo changes': 'Desfazer alterações',
        'A rotation needs at least one map.': 'A rotação precisa de pelo menos um mapa.',
        'Change role': 'Mudar papel',
        Description: 'Descrição',
        Device: 'Dispositivo',
        Dismiss: 'Descartar',
        'Done.': 'Feito.',
        Edit: 'Editar',
        Handled: 'Resolvida',
        Kick: 'Expulsar',
        'Live rooms': 'Salas ao vivo',
        'Map rotations': 'Rotações',
        Bots: 'Bots',
        Active: 'Ativo',
        '(no prefix)': '(sem prefixo)',
        'In the game': 'No jogo',
        'Saved: $1 prefixes and $2 names. Bots that join from now on use them.': 'Salvo: $1 prefixos e $2 nomes. Os bots que entrarem daqui em diante já usam.',
        '$1 active prefixes': '$1 prefixos ativos',
        '$1 active names': '$1 nomes ativos',
        'Each bot that joins draws one active prefix and one active name not in use in the room. Empty lists: "BOT " + a generated name.': 'Cada bot que entra sorteia um prefixo e um nome ativos que não estejam em uso na sala. Listas vazias: "BOT " + um nome gerado.',
        'Discard changes': 'Descartar alterações',
        'Save changes': 'Salvar alterações',
        Prefixes: 'Prefixos',
        'New prefix': 'Novo prefixo',
        Add: 'Adicionar',
        'Add "no prefix"': 'Adicionar "sem prefixo"',
        'No prefixes: bots use "BOT ".': 'Sem prefixos: os bots usam "BOT ".',
        'Possible names': 'Nomes possíveis',
        'Add names (one per line)': 'Adicionar nomes (um por linha)',
        'Search names': 'Buscar nomes',
        'No names found.': 'Nenhum nome encontrado.',
        'No names: bots get generated names.': 'Sem nomes: os bots recebem nomes gerados.',
        'Match start': 'Início da partida',
        'Team captured': 'O time capturou',
        'Team gave up the flag': 'O time entregou a bandeira',
        'Flag returned': 'Bandeira devolvida',
        'Kill streak (5, 10...)': 'Sequência de abates (5, 10...)',
        'Killed 3 times by the same player': 'Morreu 3 vezes para o mesmo jogador',
        'Score turned around': 'Virada no placar',
        Messages: 'Mensagens',
        'Player joined': 'Jogador entrou',
        'Player left': 'Jogador saiu',
        'The bot involved': 'O bot envolvido',
        'A bot of the team': 'Um bot do time',
        'A bot of the other team': 'Um bot do outro time',
        'Any bot': 'Qualquer bot',
        'Bot chat saved. It applies from the next events on.': 'Chat dos bots salvo. Vale a partir dos próximos acontecimentos.',
        'Bot chat': 'Chat dos bots',
        'Bots talk in the chat (Casual only)': 'Bots falam no chat (só no Casual)',
        'Messages per minute in the room (max)': 'Mensagens por minuto na sala (máximo)',
        'Save chat': 'Salvar chat',
        'Each event has a chance of a bot commenting, who talks and the messages (one per line; {name} = the other player). Bots wait 1 to 4 s to "type", never talk twice in a row and wait 20 s between their own messages.': 'Cada acontecimento tem a chance de um bot comentar, quem fala e as mensagens (uma por linha; {name} = o outro jogador). Os bots esperam de 1 a 4 s para "digitar", nunca falam duas vezes seguidas e esperam 20 s entre as próprias mensagens.',
        Event: 'Acontecimento',
        'Chance (%)': 'Chance (%)',
        'Who talks': 'Quem fala',
        'Clan colors in the match': 'Cores do clã na partida',
        '$1 moved to $2.': '$1 foi para o $2.',
        '$1 WINS': '$1 VENCEU',
        '$1 wins': '$1 venceu',
        'Your number $1 is freed in 7 days if you do not play.': 'Seu número $1 será liberado em 7 dias se você não jogar.',
        'Your number $1 was freed after 60 days without playing.': 'Seu número $1 foi liberado depois de 60 dias sem jogar.',
        'Number removed.': 'Número retirado.',
        'Your number is now $1.': 'Seu número agora é $1.',
        'Someone just took this number. Pick another.': 'Alguém acabou de pegar esse número. Escolha outro.',
        'You can change your number once every 30 days.': 'Você pode trocar de número uma vez a cada 30 dias.',
        'Player number': 'Número de jogador',
        'Number style': 'Estilo do número',
        'Show player numbers': 'Mostrar os números dos jogadores',
        Block: 'Bloco',
        Race: 'Corrida',
        Outline: 'Contorno',
        Stencil: 'Estêncil',
        'Number on your player': 'Número no seu boneco',
        'no number': 'sem número',
        'You can change it again on $1.': 'Você pode trocar de novo em $1.',
        'From 2 to 99, one per player; freed after 60 days without playing.': 'De 2 a 99, um por jogador; é liberado depois de 60 dias sem jogar.',
        'Use number 1 (leader of last month)': 'Usar o número 1 (líder do mês passado)',
        'Only this month; your own number stays yours.': 'Só neste mês; o seu número continua seu.',
        'Top 3 of last month: your number shows your medal colour this month.': 'Top 3 do mês passado: neste mês o seu número sai na cor da sua medalha.',
        'Top 3 of last month: choose a number to show your medal colour.': 'Top 3 do mês passado: escolha um número para exibir a cor da sua medalha.',
        'When at least 2 players of the clan are on one side and nobody from another clan, that side plays with the clan colors and tag (from the next round).': 'Quando há pelo menos 2 jogadores do clã num lado e ninguém de outro clã, esse lado joga com as cores e a tag do clã (a partir da rodada seguinte).',
        'Primary color': 'Cor primária',
        'Secondary color (used when the primary looks like the other side)': 'Cor secundária (usada quando a primária parece com a do outro lado)',
        'Pick a secondary color clearly different from the primary.': 'Escolha uma cor secundária bem diferente da primária.',
        'Pick the colors from the palette.': 'Escolha as cores da paleta.',
        Orange: 'Laranja',
        Yellow: 'Amarelo',
        Gold: 'Dourado',
        Lime: 'Lima',
        Green: 'Verde',
        Teal: 'Turquesa',
        Cyan: 'Ciano',
        Navy: 'Marinho',
        'Open the PDF': 'Abrir o PDF',
        'Game summary': 'Resumo do jogo',
        'Time with the flag': 'Tempo com a bandeira',
        // Emblema do clã (OG-481)
        'PNG $1 px': 'PNG $1 px',
        'Download matchup image': 'Baixar imagem do confronto',
        'Gold crest': 'Brasão de ouro',
        'Silver crest': 'Brasão de prata',
        'Bronze crest': 'Brasão de bronze',
        'Win a podium in the clan hall of fame.': 'Conquiste um pódio no hall da fama de clãs.',
        'Clan emblem': 'Emblema do clã',
        Frame: 'Moldura',
        Symbol: 'Símbolo',
        'Save emblem': 'Salvar emblema',
        'Back to default': 'Voltar ao padrão',
        'Another clan already uses this emblem.': 'Outro clã já usa este emblema.',
        'The emblem uses the clan colors. Without them it stays silver and black.': 'O emblema usa as cores do clã. Sem elas, fica prata e preto.',
        Fillet: 'Filete',
        'An inner line in the symbol color.': 'Uma linha interna na cor do símbolo.',
        'Swap colors': 'Inverter cores',
        'Secondary color in the background, primary in the symbol.': 'Cor secundária no fundo, primária no símbolo.',
        Shield: 'Escudo',
        Circle: 'Círculo',
        Diamond: 'Losango',
        Square: 'Quadrado',
        Octagon: 'Octógono',
        Banner: 'Estandarte',
        'No frame': 'Sem moldura',
        Star: 'Estrela',
        Chevrons: 'Divisas',
        Crown: 'Coroa',
        Wings: 'Asas',
        Crosshair: 'Mira',
        Rocket: 'Foguete',
        Lightning: 'Raio',
        Wolf: 'Lobo',
        Skull: 'Caveira',
        Flame: 'Chama',
        Tower: 'Torre',
        Gem: 'Gema',
        'Crossed swords': 'Espadas cruzadas',
        'Broken shield': 'Escudo partido',
        Fist: 'Punho fechado',
        Wall: 'Muralha',
        Phoenix: 'Fênix',
        Dragon: 'Dragão',
        Serpent: 'Serpente',
        Eagle: 'Águia',
        Shark: 'Tubarão',
        Spider: 'Aranha',
        Alien: 'Alien',
        Robot: 'Robô',
        Joystick: 'Joystick',
        Ghost: 'Fantasma',
        '8-bit heart': 'Coração 8-bit',
        Purple: 'Roxo',
        Magenta: 'Magenta',
        Pink: 'Rosa',
        Wine: 'Vinho',
        Brown: 'Marrom',
        Black: 'Preto',
        White: 'Branco',
        Silver: 'Prata',
        'Message sent to $1 rooms.': 'Mensagem enviada a $1 salas.',
        'Message to all rooms': 'Mensagem a todas as salas',
        'Minutes (empty = no end)': 'Minutos (vazio = sem fim)',
        Moderation: 'Moderação',
        'Moderators and admins only.': 'Só para moderadores e admins.',
        Mute: 'Silenciar',
        'No active bans.': 'Nenhum ban em vigor.',
        'No open reports.': 'Nenhuma denúncia aberta.',
        'No rooms online.': 'Nenhuma sala no ar.',
        'Not done: $1': 'Não feito: $1',
        'Platform ban': 'Ban de plataforma',
        Preset: 'Preset',
        'Preset removed.': 'Preset removido.',
        'Preset saved (version $1).': 'Preset salvo (versão $1).',
        Presets: 'Presets',
        'No game server has reported its maps yet; only the maps already in the rotations are listed.': 'Nenhum servidor de jogo informou seus mapas ainda; só aparecem os mapas que já estão nas rotações.',
        'Rotation saved. It applies from the next map change.': 'Rotação salva. Vale a partir da próxima troca de mapa.',
        Reason: 'Motivo',
        Remove: 'Remover',
        'Reported player': 'Denunciado',
        Reports: 'Denúncias',
        Revoke: 'Revogar',
        Role: 'Papel',
        Roles: 'Papéis',
        Room: 'Sala',
        'Save Casual preset': 'Salvar preset Casual',
        Send: 'Enviar',
        'Send the reason text as a message to this room': 'Enviar o texto do motivo como mensagem a esta sala',
        'Sending...': 'Enviando...',
        'Sent; the game server has not confirmed yet.': 'Enviado; o servidor de jogo ainda não confirmou.',
        Settings: 'Regras',
        'Settings (gamemod lines)': 'Regras (linhas de gamemod)',
        Target: 'Alvo',
        Unmute: 'Tirar silêncio',
        Until: 'Até',
        Version: 'Versão',
        admin: 'admin',
        game: 'jogo',
        moderator: 'moderador',
        muted: 'silenciado',
        'no end': 'sem fim',
        platform: 'plataforma',
        player: 'jogador',
        'Ranked matches require an account.': 'Partidas ranqueadas exigem uma conta.',
        Ranking: 'Ranking',
        'Season $1': 'Temporada $1',
        Rooms: 'Salas',
        'Create private room': 'Criar sala privada',
        Credits: 'Créditos',
        'Source code (GPL)': 'Código-fonte (GPL)',
        'Coming soon': 'Em breve',
        Up: 'Cima',
        Down: 'Baixo',
        Left: 'Esquerda',
        Right: 'Direita',
        Shoot: 'Atirar',
        Run: 'Correr',
        'Drop flag': 'Soltar bandeira',
        'Show pings': 'Mostrar pings',
        Suicide: 'Suicídio',
        'Change team': 'Mudar de time',
        'In-game help': 'Ajuda do jogo',
        'Map list': 'Lista de mapas',
        'Player stats': 'Estatísticas dos jogadores',
        'Server info': 'Informações do servidor',
        'Vote map change': 'Votar troca de mapa',
        'Show more messages': 'Mostrar mais mensagens',
        'Toggle names': 'Mostrar/esconder nomes',
        'Toggle sound': 'Ligar/desligar som',
        Screenshot: 'Captura de tela',
        'Focus mode': 'Modo foco',
        // Pausa e voto do bot substituto no Ranked (OG-264)
        'Pause (Ranked)': 'Pausa (Ranked)',
        'Vote: bot in place': 'Voto: bot no lugar',
        'Vote: play one short': 'Voto: seguir com um a menos',
        PAUSED: 'PAUSADO',
        'Resuming in $1': 'Retomando em $1',
        'Training - $1': 'Treino · $1',
        Attack: 'Ataque',
        Escape: 'Fuga',
        Capture: 'Captura',
        Defenders: 'Defensores',
        Attackers: 'Atacantes',
        Chasers: 'Perseguidores',
        'Maximum escort': 'Escolta máxima',
        'Get into the defended base and leave the base room with the flag. The bots only defend.': 'Entre na base defendida e saia da sala da base com a bandeira. Os bots só defendem.',
        'Hold your flag against a wave of attackers that leave together.': 'Segure a sua bandeira contra uma onda de atacantes que saem juntos.',
        'Start with the enemy flag in their base and capture it at yours, with chasers on your tail.': 'Comece com a bandeira inimiga na base deles e capture na sua, com perseguidores no seu encalço.',
        'A bot takes your flag home, with an escort: catch the carrier and return the flag.': 'Um bot leva a sua bandeira para casa, com escolta: alcance o portador e devolva a bandeira.',
        'You already have a training room open. Leave it before creating another.': 'Você já tem uma sala de treino aberta. Saia dela antes de criar outra.',
        'Allied bots': 'Bots aliados',
        'progressive (goes up as you succeed)': 'progressivo (sobe quando você acerta)',
        'Same start every attempt': 'Mesmo início em toda tentativa',
        '2x2': '2x2',
        '4 players and the small maps of the 2x2 rotation.': '4 jogadores e os mapas pequenos da rotação 2x2.',
        'Good for drilling one specific play.': 'Bom para repetir uma jogada específica.',
        'Each attempt starts a little differently.': 'Cada tentativa começa um pouco diferente.',
        'Attack training': 'Treino de ataque',
        'Defense training': 'Treino de defesa',
        'Escape training': 'Treino de fuga',
        'Capture training': 'Treino de captura',
        'Successes: $1 of $2 - bots level $3': 'Sucessos: $1 de $2 - bots no nível $3',
        'You died.': 'Você morreu.',
        'All defenders are down.': 'Todos os defensores caíram.',
        'You left the base with the flag.': 'Você saiu da base com a bandeira.',
        'The flag left your base.': 'A bandeira saiu da sua base.',
        'All attackers are down.': 'Todos os atacantes caíram.',
        'Flag captured at your base.': 'Bandeira capturada na sua base.',
        'The flag was delivered.': 'A bandeira foi entregue.',
        'Flag returned.': 'Bandeira devolvida.',
        'Out of time.': 'Tempo esgotado.',
        'Time: $1 s': 'Tempo: $1 s',
        'Bots now at level $1': 'Bots agora no nível $1',
        SUCCESS: 'SUCESSO',
        FAILED: 'FALHOU',
        'Pause requested by $1 ($2) - $3 s left': 'Pausa pedida por $1 ($2) - restam $3 s',
        '$1 resumes': '$1 retoma',
        '$1 lost connection': '$1 caiu',
        'Waiting for reconnection: $1 s': 'Esperando a reconexão: $1 s',
        '$1 left the game': '$1 saiu do jogo',
        '$1 team is voting: $2 s': 'Time $1 votando: $2 s',
        'Team vote: $1 s': 'Voto do time: $1 s',
        'Bot in place ($1)': 'Bot no lugar ($1)',
        'Play one short ($1)': 'Seguir com um a menos ($1)',
        'Pause left - Red: $1 s ($2) Blue: $3 s ($4)': 'Saldo de pausa - Vermelho: $1 s ($2) Azul: $3 s ($4)',
        'Control scheme': 'Esquema de teclas',
        Classic: 'Clássico',
        'Browser (no Ctrl/Alt)': 'Navegador (sem Ctrl/Alt)',
        'Custom': 'Personalizado',
        'Restore defaults': 'Restaurar padrão',
        'Press a key for $1 (Esc cancels)': 'Pressione uma tecla para $1 (Esc cancela)',
        'Enter adds a key, Delete restores the default.': 'Enter acrescenta uma tecla, Delete volta ao padrão.',
        '$1: coming soon': '$1: em breve',
        'Focus mode: full screen, browser shortcuts captured (F10 or Esc leaves).': 'Modo foco: tela cheia, atalhos do navegador capturados (F10 ou Esc sai).',
        'Back to game': 'Voltar ao jogo',
        // menu do Esc na partida (OG-339)
        On: 'Sim',
        Off: 'Não',
        Music: 'Música',
        'Controls...': 'Controles...',
        'Options...': 'Opções...',
        'New version available: reload': 'Nova versão disponível: recarregar',
        // OG-289: bots das salas Casual
        'Bots in your Casual rooms': 'Bots das suas salas Casual',
        Menus: 'Menus',
        'Menu look': 'Visual dos menus',
        'Field (green, like the rooms)': 'Campo (verde, como as salas)',
        'Scoreboard (black, like the scoreboard)': 'Placar (preto, como o placar)',
        'Only the screens outside the game change.': 'Só as telas fora da partida mudam.',
        'HUD scale': 'Escala do HUD',
        'automatic (by screen size)': 'automática (pelo tamanho da tela)',
        'Size of the chat, scoreboard and bars during the game.': 'Tamanho do chat, do placar e das barras durante a partida.',
        // OG-297 a OG-300: estilos do HUD (D-55)
        'HUD style': 'Estilo do HUD',
        'Classic (like the original)': 'Clássico (como o original)',
        'Modern (big room, frags on TAB)': 'Moderno (sala grande, frags no TAB)',
        'Nothing is drawn over the room in any style.': 'Em nenhum estilo há nada desenhado sobre a sala.',
        Weapon: 'Arma',
        Scoreboard: 'Placar',
        'Release TAB to close': 'Solte o TAB para fechar',
        'Edit custom HUD': 'Editar HUD personalizado',
        'Classic HUD: frags only on TAB': 'HUD clássico: frags só no TAB',
        'Edit custom HUD...': 'Editar HUD personalizado...',
        'Opens an example match where you move, resize and hide each part of the HUD.': 'Abre uma partida de exemplo onde você move, aumenta e esconde cada parte do HUD.',
        'Drag each part of the HUD; pull the yellow corner to resize. Nothing can stay over the room.': 'Arraste cada parte do HUD; puxe o canto amarelo para mudar o tamanho. Nada pode ficar sobre a sala.',
        'Room on the left': 'Sala à esquerda',
        'Room in the centre': 'Sala centralizada',
        'Team score and clock': 'Placar dos times e relógio',
        Minimap: 'Minimapa',
        Chat: 'Chat',
        'Power-ups and weapon': 'Power-ups e arma',
        'Hold the base, I will get the flag': 'segura a base que eu vou buscar a bandeira',
        'Someone go back to defense': 'alguém volta pra defesa',
        'Number of bots': 'Quantidade de bots',
        'Bot level': 'Nível dos bots',
        'variable (each bot different)': 'variável (cada bot com um nível)',
        '1 (weak)': '1 (fraco)',
        '4 (standard)': '4 (padrão)',
        '5 (strong)': '5 (forte)',
        'Used when you create a private room and, as the room owner, from the next game on (game menu).': 'Valem ao criar uma sala privada e, como dono da sala, a partir da próxima partida (menu do jogo).',
        'Choose the bots': 'Escolher os bots',
        'The rules decide the bots.': 'Os bots seguem as regras escolhidas.',
        'Bots from my options at the next game: $1, level $2': 'Bots das minhas opções na próxima partida: $1, nível $2',
        'Bots from my options and restart now': 'Bots das minhas opções e reiniciar agora',
        'Tip: F10 plays in focus mode, which keeps browser shortcuts inside the game.': 'Dica: F10 joga no modo foco, que segura os atalhos do navegador dentro do jogo.',
        '$1 may be taken by the browser or the system. Pick another key or play in focus mode (F10).': '$1 pode ser tomada pelo navegador ou pelo sistema. Escolha outra tecla ou jogue no modo foco (F10).',
        'Focus mode (F10) plays in full screen and, in Chrome and Edge, keeps browser shortcuts such as Ctrl+W or Cmd+1 inside the game. System shortcuts (Alt+Tab, Cmd+Tab) always leave the game.': 'O modo foco (F10) joga em tela cheia e, no Chrome e no Edge, segura dentro do jogo atalhos do navegador como Ctrl+W ou Cmd+1. Atalhos do sistema (Alt+Tab, Cmd+Tab) sempre saem do jogo.',
        'May be taken by the browser or the system': 'Pode ser tomada pelo navegador ou pelo sistema',
        'Option+$1': 'Option+$1',
        'Leave game': 'Sair da partida',
        'Press Esc for the menu': 'Pressione Esc para o menu',
        'Connecting to the game server...': 'Conectando ao servidor de jogo...',
        // mensagens com cor (o catálogo do 1.0.3 só tem as versões sem `$R`/`$B`/`$G`)
        '$1 CAPTURED THE $RRED FLAG$>!': '$1 CAPTUROU A BANDEIRA $RVERMELHA$>!',
        '$1 CAPTURED THE $BBLUE FLAG$>!': '$1 CAPTUROU A BANDEIRA $BAZUL$>!',
        '$1 CAPTURED THE $GWILD FLAG$>!': '$1 CAPTUROU A BANDEIRA $GSELVAGEM$>!',
        '$1 LOST THE $RRED FLAG$>!': '$1 PERDEU A BANDEIRA $RVERMELHA$>!',
        '$1 LOST THE $BBLUE FLAG$>!': '$1 PERDEU A BANDEIRA $BAZUL$>!',
        '$1 LOST THE $GWILD FLAG$>!': '$1 PERDEU A BANDEIRA $GSELVAGEM$>!',
        '$1 GOT THE $RRED FLAG$>!': '$1 PEGOU A BANDEIRA $RVERMELHA$>!',
        '$1 GOT THE $BBLUE FLAG$>!': '$1 PEGOU A BANDEIRA $BAZUL$>!',
        '$1 GOT THE $GWILD FLAG$>!': '$1 PEGOU A BANDEIRA $GSELVAGEM$>!',
        '$1 RETURNED THE $RRED FLAG$>!': '$1 RETORNOU A BANDEIRA $RVERMELHA$>!',
        '$1 RETURNED THE $BBLUE FLAG$>!': '$1 RETORNOU A BANDEIRA $BAZUL$>!',
        '$1 DROPPED THE $RRED FLAG$>!': '$1 SOLTOU A BANDEIRA $RVERMELHA$>!',
        '$1 DROPPED THE $BBLUE FLAG$>!': '$1 SOLTOU A BANDEIRA $BAZUL$>!',
        '$1 DROPPED THE $GWILD FLAG$>!': '$1 SOLTOU A BANDEIRA $GSELVAGEM$>!',
        'CTF GAME OVER - FINAL SCORE: $RRED $1$> - $BBLUE $2$>': 'FIM DE JOGO - PLACAR FINAL: $RVERMELHO $1$> - $BAZUL $2$>',
        'Show minimap and scoreboard': 'Mostrar minimapa e placar',
        'Outgun Web is a port of Outgun 1.0.3 to the browser.': 'Outgun Web é um port do Outgun 1.0.3 para o navegador.',
        'Outgun and Outgun Web are free software under the GNU GPL, version 2 or later.': 'Outgun e Outgun Web são software livre sob a GNU GPL, versão 2 ou posterior.',
        'You may use, study, change and share the game. Whoever distributes it must also offer its complete source code under the same license.': 'Você pode usar, estudar, modificar e compartilhar o jogo. Quem o distribui deve oferecer também o código-fonte completo, sob a mesma licença.',
        'The public repository of Outgun Web will be announced at launch.': 'O repositório público do Outgun Web será divulgado no lançamento.',
        // Contas (OG-081)
        'E-mail': 'E-mail',
        'Confirm password': 'Confirmar senha',
        'Current password': 'Senha atual',
        'Reset password': 'Redefinir senha',
        'Save': 'Salvar',
        'Account': 'Conta',
        'Change password': 'Trocar senha',
        'Export my data': 'Exportar meus dados',
        'Delete account': 'Excluir conta',
        'Delete account permanently': 'Excluir conta para sempre',
        'This e-mail is already in use. Forgot your password?': 'Este e-mail já está em uso. Esqueceu a senha?',
        'Invalid username: up to 15 characters, no spaces at the ends.': 'Nome inválido: até 15 caracteres, sem espaços nas pontas.',
        'Invalid e-mail.': 'E-mail inválido.',
        'The passwords do not match.': 'As senhas não conferem.',
        'This link is invalid or has expired. Ask for a new one.': 'Este link é inválido ou expirou. Peça outro.',
        'Too many requests. Try again later.': 'Pedidos demais. Tente mais tarde.',
        'Could not reach the server.': 'Não foi possível falar com o servidor.',
        'Something went wrong. Try again.': 'Algo deu errado. Tente de novo.',
        'Wrong password.': 'Senha incorreta.',
        'Create Ranked room': 'Criar sala ranqueada',
        Format: 'Formato',
        'Ranked rooms': 'Salas ranqueadas',
        'No Ranked rooms open. Create one and invite your friends.': 'Nenhuma sala ranqueada aberta. Crie uma e chame seus amigos.',
        Series: 'Série',
        Phase: 'Fase',
        'Waiting for players': 'Aguardando jogadores',
        'Map vote': 'Votação de mapa',
        'Getting ready': 'Preparando',
        'In game': 'Em jogo',
        'Series over': 'Série encerrada',
        'Single game': 'Jogo único',
        'Best of 3': 'Melhor de 3',
        'Best of 5': 'Melhor de 5',
        'Create and enter the lobby': 'Criar e entrar no lobby',
        '$1 players per team.': '$1 jogadores por time.',
        'Ranked rules are fixed: the password only limits who can join.': 'As regras do ranqueado são fixas: a senha só limita quem pode entrar.',
        'Now on Outgun': 'Agora no Outgun',
        'Series in progress: $1 × $2': 'Série em andamento: $1 × $2',
        'Series tied $1 × $2': 'Série empatada em $1 × $2',
        'Red team wins the series $1 × $2': 'O time vermelho venceu a série por $1 × $2',
        'Blue team wins the series $1 × $2': 'O time azul venceu a série por $1 × $2',
        'Best of $1': 'Melhor de $1',
        'Series page': 'Página da série',
        'Games of the series': 'Jogos da série',
        'No games yet.': 'Nenhum jogo ainda.',
        'Game $1': 'Jogo $1',
        'Back to the main menu in $1 s.': 'Voltando ao menu inicial em $1 s.',
        'Outgun is not available on phones yet.': 'O Outgun ainda não está disponível para celular.',
        'Open this page on a computer to play.': 'Abra esta página no computador para jogar.',
        'player online': 'jogador online',
        'players online': 'jogadores online',
        'Nobody is playing right now. Start a match with "Play now" and others will join.': 'Ninguém está jogando agora. Comece uma partida em "Jogar agora" e os outros chegam.',
        'Rooms with players': 'Salas com jogadores',
        'Played in $1': 'Jogado em: $1',
        'Game servers': 'Servidores de jogo',
        'No game server yet.': 'Nenhum servidor de jogo ainda.',
        Draining: 'Drenando',
        Server: 'Servidor',
        Online: 'No ar',
        Offline: 'Fora do ar',
        'Last heartbeat': 'Último sinal',
        'Ranking: $1': 'Ranking: $1',
        'Full ranking': 'Ranking completo',
        'No active season right now.': 'Nenhuma temporada ativa agora.',
        'Top 5 of the season': 'Os 5 primeiros da temporada',
        'Nobody in the ranking yet. Be the first: play Ranked.': 'Ninguém no ranking ainda. Seja o primeiro: jogue ranqueado.',
        'Rating': 'Rating',
        'You: $1º of $2': 'Você: $1º de $2',
        'Play Ranked to enter the ranking.': 'Jogue ranqueado para entrar no ranking.',
        'Ready': 'Pronto',
        'Not ready': 'Não está pronto',
        'Voted': 'Votou',
        'Ask to swap': 'Pedir troca',
        'Open slot': 'Vaga livre',
        'Move to this side': 'Ir para este lado',
        'Ranked lobby': 'Lobby ranqueado',
        'Game $1 of $2': 'Jogo $1 de $2',
        'Starting in $1': 'Começa em $1',
        'Series tied': 'Série empatada',
        'Red team wins the series': 'O time vermelho venceu a série',
        'Blue team wins the series': 'O time azul venceu a série',
        '$1 of $2 players. The vote starts when the room is full.': '$1 de $2 jogadores. A votação começa quando a sala encher.',
        '$1 s to vote': '$1 s para votar',
        '$1 s to mark Ready': '$1 s para marcar Pronto',
        '$1 votes': '$1 votos',
        'Cancel ready': 'Cancelar pronto',
        '$1 wants to swap sides with you.': '$1 quer trocar de lado com você.',
        'Swap request sent to $1.': 'Pedido de troca enviado para $1.',
        'Leave room': 'Sair da sala',
        'Room chat': 'Chat da sala',
        'Message': 'Mensagem',
        'Password changed. Other sessions were signed out.': 'Senha trocada. As outras sessões foram encerradas.',
        'Your account and personal data are erased. Past matches stay, without your name.': 'Sua conta e seus dados pessoais são apagados. As partidas jogadas ficam, sem o seu nome.',
        // Nomes (OG-082)
        'Change name': 'Trocar nome',
        'New name': 'Novo nome',
        'Saved.': 'Salvo.',
        'Name changed to $1.': 'Nome trocado para $1.',
        'You can change your name again on $1.': 'Você poderá trocar de nome de novo em $1.',
        'Once every 30 days. Your old name stays reserved for you for 90 days.': 'Uma vez a cada 30 dias. Seu nome antigo fica reservado para você por 90 dias.',
        // A clan tag virou clã (OG-270)
        'The clan tag is now the tag of your clan: free tags were removed. Create or join a clan to show its tag next to your name.': 'A clan tag agora é a tag do seu clã: as tags livres foram removidas. Crie ou entre num clã para mostrar a tag dele junto do seu nome.',
        // Telas de clã (OG-272)
        '$1 members': '$1 membros',
        '1 to 3 characters.': '1 a 3 caracteres.',
        // estilo da tag do clã (OG-338)
        'Tag in game': 'Tag no jogo',
        'How the tag appears next to the names of the members.': 'Como a tag aparece junto do nome dos membros.',
        '3 to 24 characters.': '3 a 24 caracteres.',
        Actions: 'Ações',
        'All clans': 'Todos os clãs',
        'Ask to join': 'Pedir para entrar',
        'Clan name': 'Nome do clã',
        'Clan page': 'Página do clã',
        'Create clan': 'Criar clã',
        Demote: 'Rebaixar',
        'Dissolve clan': 'Dissolver clã',
        'Dissolve the clan for good? Every member loses the tag.': 'Dissolver o clã de vez? Todos os membros perdem a tag.',
        'Edit clan': 'Editar clã',
        Founded: 'Fundado',
        'Founded on $1': 'Fundado em $1',
        'Invalid name: 3 to 24 characters.': 'Nome inválido: 3 a 24 caracteres.',
        'Invalid tag: 1 to 3 characters, no parentheses.': 'Tag inválida: 1 a 3 caracteres, sem parênteses.',
        'Invite a player': 'Convidar jogador',
        'Invite sent to $1.': 'Convite enviado para $1.',
        'Invites waiting for an answer:': 'Convites aguardando resposta:',
        Leader: 'Líder',
        'Leave clan': 'Sair do clã',
        'Leave the clan? You will wait 7 days to join another.': 'Sair do clã? Você vai esperar 7 dias para entrar em outro.',
        'Make leader': 'Tornar líder',
        'My clan': 'Meu clã',
        'No clans yet.': 'Nenhum clã ainda.',
        'Only the leader changes the tag.': 'Só o líder muda a tag.',
        'Pass the leadership to $1?': 'Passar a liderança para $1?',
        'Player not found.': 'Jogador não encontrado.',
        Promote: 'Promover',
        'Remove $1 from the clan?': 'Tirar $1 do clã?',
        'Request sent.': 'Pedido enviado.',
        'Search by clan name or tag': 'Buscar por nome ou tag do clã',
        Since: 'Desde',
        Tag: 'Tag',
        'This clan already invited you: accept the invite.': 'Este clã já convidou você: aceite o convite.',
        'This clan name is already taken.': 'Este nome de clã já está em uso.',
        'This player already asked to join: approve the request.': 'Este jogador já pediu para entrar: aprove o pedido.',
        'This player is already in the clan.': 'Este jogador já está no clã.',
        'This tag is already taken.': 'Esta tag já está em uso.',
        'You are the last member: leaving dissolves the clan. Leave?': 'Você é o último membro: sair dissolve o clã. Sair?',
        'Your clan and the clan directory': 'Seu clã e o diretório de clãs',
        'Your role in the clan does not allow this.': 'Seu papel no clã não permite isso.',
        'Create or join a clan': 'Crie um clã ou entre num',
        Admin: 'Admin',
        Member: 'Membro',
        Invite: 'Convidar',
        // Clã x clã (OG-259)
        'Clan vs clan': 'Clã x clã',
        // Partida Ranked com desconexão permanente (OG-263)
        'Completed with bots': 'Concluída com bots',
        'Short-handed': 'Com um a menos',
        // Hall da fama (OG-268)
        'Hall of fame': 'Hall da fama',
        'The top 3 of every finished season: overall, in each format and among clans.': 'Os 3 primeiros de cada temporada encerrada: no geral, em cada formato e entre os clãs.',
        'Nobody qualified.': 'Ninguém se classificou.',
        Champion: 'Campeão',
        '2nd place': '2º lugar',
        '3rd place': '3º lugar',
        '$1 points': '$1 pontos',
        // Ranking de clãs (OG-274)
        'Clan vs clan matches: win 3 points, draw 1; ties broken by capture difference; at least 3 matches to appear.': 'Partidas clã x clã: vitória vale 3 pontos, empate 1; desempate pelo saldo de capturas; mínimo de 3 partidas para aparecer.',
        'Capture difference': 'Saldo de capturas',
        Points: 'Pontos',
        // Estatísticas do clã (OG-273)
        Period: 'Período',
        'Series won': 'Séries vencidas',
        Opponents: 'Adversários',
        'No clan vs clan match yet.': 'Nenhuma partida clã x clã ainda.',
        'Members for the clan': 'Membros pelo clã',
        '$1 matches as a clan · $2 kills · $3 captures': '$1 partidas pelo clã · $2 kills · $3 capturas',
        // Rating por formato (OG-258)
        'All formats': 'Todos',
        'Matches from before the formats only show under "All".': 'Partidas anteriores aos formatos só aparecem em "Todos".',
        // Temporadas mensais e ranking geral (OG-267)
        'All seasons': 'Geral',
        'Current season': 'Temporada atual',
        'No finished season yet.': 'Nenhuma temporada encerrada ainda.',
        'Past seasons': 'Temporadas anteriores',
        'Ranked players in $1 seasons: $2': 'Jogadores no ranking de $1 temporadas: $2',
        Season: 'Temporada',
        // Moderação de clãs (OG-275)
        'Confirm dissolution of $1': 'Confirmar dissolução de $1',
        'Force change': 'Forçar troca',
        Moderate: 'Moderar',
        'Report clan': 'Denunciar clã',
        'Report sent. Thanks.': 'Denúncia enviada. Obrigado.',
        'Send report': 'Enviar denúncia',
        'This name is not allowed.': 'Este nome não é permitido.',
        'What is wrong with this clan?': 'O que há de errado com este clã?',
        'You already reported this clan.': 'Você já denunciou este clã.',
        // Convites e pedidos de clã (OG-271)
        'Clan invites': 'Convites de clã',
        'Invites received': 'Convites recebidos',
        'No invites.': 'Nenhum convite.',
        'Your request': 'Seu pedido',
        'Requests to your clan': 'Pedidos ao seu clã',
        Accept: 'Aceitar',
        Decline: 'Recusar',
        Approve: 'Aprovar',
        Withdraw: 'Retirar',
        'Expires on $1': 'Vence em $1',
        'You can join another clan on $1.': 'Você poderá entrar em outro clã em $1.',
        'Leave your clan before joining another.': 'Saia do seu clã antes de entrar em outro.',
        'You left a clan recently. Wait 7 days to join another.': 'Você saiu de um clã há pouco. Espere 7 dias para entrar em outro.',
        'The clan is full.': 'O clã está cheio.',
        'You already have an open request.': 'Você já tem um pedido aberto.',
        // Entrada na sala (OG-083)
        'This name belongs to an account. Sign in or choose another.': 'Este nome pertence a uma conta. Entre ou escolha outro.',
        'Invalid name.': 'Nome inválido.',
        'You are banned from this room.': 'Você está banido desta sala.',
        'This room needs a password.': 'Esta sala exige senha.',
        'The room is full.': 'A sala está cheia.',
        'The room is not running.': 'A sala não está no ar.',
        'Room not found.': 'Sala não encontrada.',
        // Reconexão (OG-047)
        'Connection lost. Reconnecting...': 'Conexão perdida. Reconectando...',
        'The game continued in another window.': 'A partida continuou em outra janela.',
        // OG-085: perfil, histórico, partida e ranking
        'Not found.': 'Não encontrado.',
        'Loading...': 'Carregando...',
        'Matches': 'Partidas',
        'Wins': 'Vitórias',
        'Losses': 'Derrotas',
        'Draws': 'Empates',
        'Frags': 'Frags',
        'Kills': 'Mortes causadas',
        'Deaths': 'Mortes',
        'Captures': 'Capturas',
        'Assists': 'Assistências',
        'Flags returned': 'Bandeiras devolvidas',
        'Carriers killed': 'Portadores mortos',
        'Hit accuracy': 'Precisão',
        'Playing time': 'Tempo de jogo',
        'position $1 of $2': 'posição $1 de $2',
        'not ranked yet ($1 points needed)': 'ainda fora do ranking (são precisos $1 pontos)',
        'score': 'score',
        'neg': 'neg',
        'rating': 'rating',
        'Statistics': 'Estatísticas',
        'All': 'Todas',
        'No matches yet.': 'Nenhuma partida ainda.',
        'Date': 'Data',
        'Mode': 'Modo',
        'Map': 'Mapa',
        'Score': 'Placar',
        'Result': 'Resultado',
        'Win': 'Vitória',
        'Loss': 'Derrota',
        'Draw': 'Empate',
        'More': 'Mais',
        'Suicides': 'Suicídios',
        'Flags taken': 'Bandeiras pegas',
        'Flags dropped': 'Bandeiras largadas',
        'Carry time': 'Tempo com bandeira',
        'Cons. kills': 'Seq. de mortes causadas',
        'Cons. deaths': 'Seq. de mortes',
        'Shots': 'Tiros',
        'Accuracy': 'Precisão',
        'Shots taken': 'Tiros recebidos',
        'Movement': 'Movimento',
        'Total movement': 'Movimento total',
        'Match': 'Partida',
        'Game info': 'Informações da partida',
        'did not count for the ranking': 'não contou para o ranking',
        'Capture limit': 'Limite de capturas',
        'none': 'nenhum',
        'difference of $1': 'diferença de $1',
        'Time limit': 'Limite de tempo',
        'Extra time': 'Prorrogação',
        'How the rating works': 'Como funciona o rating',
        'Your rating measures your skill from the results of your Ranked matches, using OpenSkill (Plackett-Luce model).': 'O seu rating mede a sua habilidade pelos resultados das suas partidas Ranqueadas, com o OpenSkill (modelo Plackett-Luce).',
        'your estimated skill. It goes up when your team wins and down when it loses.': 'a sua habilidade estimada. Sobe quando o seu time vence e desce quando perde.',
        'how sure the system is about you. It starts high and shrinks with each match.': 'o quanto o sistema tem certeza sobre você. Começa alta e diminui a cada partida.',
        'Beating a stronger team earns a lot; losing to a stronger team costs little. The bigger the surprise, the bigger the change.': 'Vencer um time mais forte rende muito; perder para um time mais forte custa pouco. Quanto maior a surpresa, maior a mudança.',
        'Example: in a 3x3 where the other team was the favourite (86%), beating them gave +77; losing to them would have cost -20.': 'Exemplo: num 3x3 em que o outro time era o favorito (86%), vencê-lo rendeu +77; perder para ele teria custado -20.',
        'Everyone starts at 0. The first matches move the rating fast; with fewer than 10 Ranked matches you are still calibrating.': 'Todo mundo começa em 0. As primeiras partidas mexem rápido no rating; com menos de 10 Ranqueadas você ainda está em calibração.',
        'One rating for all formats (2x2, 3x3, 4x4, 5x5), kept for good: it does not restart each month and does not drop if you stop playing.': 'Um rating só para todos os formatos (2x2, 3x3, 4x4, 5x5), permanente: não recomeça todo mês e não cai se você parar de jogar.',
        'Only the result counts (win, loss or draw), not the score margin.': 'Só o resultado conta (vitória, derrota ou empate), não a diferença no placar.',
        'Everyone who started the match gets the team result, even if they left. Substitute bots have no rating.': 'Todo mundo que começou a partida recebe o resultado do time, mesmo quem saiu. Bots substitutos não têm rating.',
        'The monthly competition is the leaderboard, with a ranking for each individual stat.': 'A competição do mês é o leaderboard, com um ranking para cada estatística individual.',
        'Rating $1': 'Rating $1',
        'Rating $1 · calibrating ($2/$3)': 'Rating $1 · em calibração ($2/$3)',
        'No rating yet: play Ranked': 'Ainda sem rating: jogue Ranqueado',
        'No ranked matches yet.': 'Nenhuma partida ranqueada ainda.',
        'Predicted win chance: red $1% · blue $2%': 'Chance prevista de vitória: vermelho $1% · azul $2%',
        'your team had $1% to win': 'seu time tinha $1% de chance de vencer',
        'Only Ranked counts. Casual matches and cancelled matches do not change your rating.': 'Só o Ranked conta. Partidas Casual e partidas canceladas não mudam o rating.',
        'Victory': 'Vitória',
        'Defeat': 'Derrota',
        'Game over': 'Fim de jogo',
        'Returns': 'Devoluções',
        'Time is up': 'Fim do tempo',
        'Capture limit reached': 'Limite de capturas atingido',
        'End of extra time': 'Fim da prorrogação',
        'Map changed by vote': 'Mapa trocado por voto',
        'Continue ($1)': 'Continuar ($1)',
        'IF TIED, $1 MINUTES OF EXTRA TIME.': 'EMPATE NO FIM: $1 MINUTOS DE PRORROGAÇÃO.',
        'sudden death': 'morte súbita',
        'Replay': 'Replay',
        'Watch': 'Assistir',
        'Open replay file': 'Abrir arquivo de replay',
        'Watch live': 'Assistir ao vivo',
        'Connecting to the live match: it appears after the delay.': 'Conectando à partida ao vivo: ela aparece depois do atraso.',
        'Live': 'Ao vivo',
        'Match over': 'Partida encerrada',
        'The match is over.': 'A partida terminou.',
        '$1 s delay': 'atraso de $1 s',
        'Live with $1 s delay: the match appears after the delay.': 'Ao vivo com atraso de $1 s: a partida aparece depois do atraso.',
        'Arrows room · F follow player · keypad +/- zoom · M sound': 'Setas sala · F seguir jogador · +/- do teclado numérico zoom · M som',
        'Arrows room · F follow player · A follow the flag · keypad +/- zoom · M sound · N music · H hide this bar': 'Setas sala · F seguir jogador · A seguir a bandeira · +/- do teclado numérico zoom · M som · N música · H esconde esta barra',
        'following the flag': 'seguindo a bandeira',
        'Copy broadcast link': 'Copiar link de transmissão',
        'Broadcast link copied: open it in the OBS browser source.': 'Link de transmissão copiado: abra na fonte de navegador do OBS.',
        'Click to turn on the sound.': 'Clique para ligar o som.',
        'Aim': 'Mira',
        'Targets': 'Alvos',
        '1 minute shooting the bot caged in the middle of T4: at least 70 shots and 90% accuracy. Hit the goal and you switch sides.': '1 minuto atirando no bot preso no meio do T4: no mínimo 70 tiros e 90% de precisão. Bateu a meta, troca de lado.',
        'The aim training is solo: no guests in this room.': 'O treino de mira é individual: sem convidados nesta sala.',
        'Shots $1/$2 - accuracy $3% (goal $4%)': 'Tiros $1/$2 - precisão $3% (meta $4%)',
        'Aim training': 'Treino de mira',
        'from the left': 'pela esquerda',
        'from the right': 'pela direita',
        'Successes: $1 of $2': 'Sucessos: $1 de $2',
        'Goal reached: switching sides.': 'Meta batida: troca de lado.',
        'Fewer than $1 shots.': 'Menos de $1 tiros.',
        'Accuracy below $1%.': 'Precisão abaixo de $1%.',
        'Goal: $1 shots and $2% accuracy in $3 s.': 'Meta: $1 tiros e $2% de precisão em $3 s.',
        '$1: revision $2 saved as a draft. Test it in a private room, then activate it in the history.': '$1: revisão $2 salva como rascunho. Teste numa sala privada e depois ative no histórico.',
        'Publish as a draft': 'Publicar como rascunho',
        'A draft does not go into the rotations: only a moderator can pick it in a private room, and those matches do not count.': 'Rascunho não entra nas rotações: só um moderador o escolhe numa sala privada, e essas partidas não contam.',
        'Save draft': 'Salvar rascunho',
        'Older than the active revision: activate anyway?': 'Mais antigo que a revisão ativa: ativar mesmo assim?',
        '$1: revision $2 published. It applies from the next map change.': '$1: revisão $2 publicada. Vale a partir da próxima troca de mapa.',
        'A new map': 'Um mapa novo',
        'A new revision of $1': 'Uma revisão nova de $1',
        'Activate': 'Ativar',
        'Activate this draft': 'Ativar este rascunho',
        'After': 'Depois',
        'Author: $1 > $2': 'Autor: $1 > $2',
        'Based on revision $1, the active one.': 'Baseada na revisão $1, a ativa.',
        'Bases swapped: red is where blue was.': 'Bases trocadas: o vermelho está onde era o azul.',
        'Before': 'Antes',
        'Circular walls: $1 > $2': 'Paredes circulares: $1 > $2',
        'Download TXT': 'Baixar TXT',
        'Flags ($1): $2 > $3': 'Bandeiras ($1): $2 > $3',
        'Flags moved.': 'Bandeiras mudaram de lugar.',
        'Floor pieces: $1 > $2': 'Peças de chão: $1 > $2',
        'History': 'Histórico',
        'History of $1': 'Histórico de $1',
        'Map activated for new matches.': 'Mapa ativado para novas partidas.',
        'Origin': 'Origem',
        'Playable': 'Jogável',
        'Possible duplicate of: $1. If it is the same map, choose "A new revision of" instead.': 'Possível duplicata de: $1. Se for o mesmo mapa, escolha "Uma revisão nova de".',
        'Publish anyway': 'Publicar mesmo assim',
        'Publish revision': 'Publicar revisão',
        'Restore': 'Restaurar',
        'Revision note (optional)': 'Nota da revisão (opcional)',
        'Revisions': 'Revisões',
        'Rotations': 'Rotações',
        'Same geometry (only text or comments changed).': 'Mesma geometria (só mudou texto ou comentário).',
        'Send a map .txt in the Outgun format: a new map or a new revision of any map. The title comes from the file (P title).': 'Envie um .txt de mapa no formato do Outgun: um mapa novo ou uma revisão nova de qualquer mapa. O título vem do arquivo (P title).',
        'Size: $1 > $2': 'Tamanho: $1 > $2',
        'Spawn points ($1): $2 > $3': 'Pontos de nascimento ($1): $2 > $3',
        'The file was in UTF-8 and was converted to Latin-1, like the game maps.': 'O arquivo estava em UTF-8 e foi convertido para Latin-1, como os mapas do jogo.',
        'This file is': 'Este arquivo é',
        'Title: $1 > $2': 'Título: $1 > $2',
        'Walls: $1 > $2': 'Paredes: $1 > $2',
        'blue': 'azul',
        'draft': 'rascunho',
        'from revision $1': 'a partir da revisão $1',
        'imported': 'importado',
        'panel': 'painel',
        'red': 'vermelho',
        'yes': 'sim',
        Revision: 'Revisão',
        'All revisions': 'Todas as revisões',
        'Revision $1': 'Revisão $1',
        'Current map: the match may have had other walls.': 'Mapa atual: a partida pode ter tido outras paredes.',
        'The map of this match was not found; the walls may be different.': 'O mapa desta partida não foi encontrado; a geometria pode estar diferente.',
        'Disconnected': 'Desconectado',
        'My matches': 'Minhas partidas',
        'No replay chosen.': 'Nenhum replay escolhido.',
        'Replay not found': 'Replay não encontrado',
        'paused': 'pausado',
        'following $1': 'seguindo $1',
        'room $1': 'sala $1',
        'Position': 'Posição',
        'Play': 'Tocar',
        'Pause': 'Pausar',
        'Copy link': 'Copiar link',
        'Link copied': 'Link copiado',
        'Could not copy': 'Não deu para copiar',
        'Back': 'Voltar',
        'PgUp/PgDn speed · Home normal · P pause · arrows room · F follow player · keypad +/- zoom · M sound': 'PgUp/PgDn velocidade · Home normal · P pausa · setas sala · F seguir jogador · +/- do teclado numérico zoom · M som',
        'Team stats': 'Estatísticas dos times',
        'Team': 'Time',
        'Red': 'Vermelho',
        'Blue': 'Azul',
        'Player': 'Jogador',
        'Red team': 'Time vermelho',
        'Blue team': 'Time azul',
        'Time': 'Tempo',
        'Capturer': 'Capturador',
        'Ranked players: $1': 'Jogadores no ranking: $1',
        'Rating = (score + 1) / (neg + 1); at least 100 points of score to appear. Only Ranked matches count.': 'Rating = (score + 1) / (neg + 1); são precisos 100 pontos de score para aparecer. Só partidas ranqueadas contam.',
        'My profile': 'Meu perfil',
        // OG-069: lobby de salas
        'Name': 'Nome',
        'needs an account': 'exige conta',
        'Casual only': 'só no Casual',
        'No room available right now.': 'Nenhuma sala disponível agora.',
        'No rooms open. "Play now" opens one.': 'Nenhuma sala aberta. "Jogar agora" abre uma.',
        'Players': 'Jogadores',
        'Join': 'Entrar na sala',
        'Copy invite link': 'Copiar link de convite',
        'Official rotation': 'Rotação oficial',
        '$1 maps': '$1 mapas',
        'Done': 'Pronto',
        'Maps': 'Mapas',
        'Too many rooms. Try again later.': 'Salas demais. Tente mais tarde.',
        'Could not create the room.': 'Não foi possível criar a sala.',
        'Room name': 'Nome da sala',
        'Rules': 'Regras',
        'Password (optional)': 'Senha (opcional)',
        'Create and play': 'Criar e jogar',
        // OG-068: opções do jogador
        'Player options': 'Opções do jogador',
        'Game options': 'Opções de jogo',
        'Quick messages': 'Mensagens rápidas',
        'Graphic options': 'Opções gráficas',
        'Sound options': 'Opções de som',
        'Favorite colors': 'Cores favoritas',
        'Click a colour to make it your first choice; Ctrl+arrows reorder.': 'Clique numa cor para torná-la a primeira escolha; Ctrl+setas reordenam.',
        'Changes are saved automatically on this browser.': 'As mudanças são salvas automaticamente neste navegador.',
        'Changes are saved automatically to your account.': 'As mudanças são salvas automaticamente na sua conta.',
        'Saving to your account...': 'Salvando na conta...',
        'Saved to your account.': 'Salvo na conta.',
        'Could not save to your account; changes are kept on this browser.': 'Não foi possível salvar na conta; as mudanças ficam neste navegador.',
        'Use random color': 'Usar cor aleatória',
        'Registration status': 'Situação do registro',
        'logged in as $1': 'conectado como $1',
        'Take part in the ranking': 'Participar do ranking',
        'Bandwidth for out-of-room players (cps)': 'Banda para jogadores fora da sala (cps)',
        'Show flag messages': 'Mostrar mensagens de bandeira',
        'Show killing messages': 'Mostrar mensagens de morte',
        'Show stats after the round': 'Mostrar estatísticas após a rodada',
        'off': 'desligado',
        'teams': 'times',
        'Show server info when connected': 'Mostrar informações do servidor ao conectar',
        'Skip maps in rotation': 'Pular mapas da rotação',
        'dimmed': 'escurecidos',
        'all but highlighted': 'todos menos os destacados',
        'Enable quick messages': 'Ativar mensagens rápidas',
        'Send message immediately': 'Enviar a mensagem na hora',
        'Alt+$1': 'Alt+$1',
        'Colour theme': 'Tema de cores',
        'Prefer main theme colours': 'Preferir as cores do tema principal',
        '<default>': '<padrão>',
        'Show player names': 'Mostrar nomes dos jogadores',
        'never': 'nunca',
        'in same room': 'na mesma sala',
        'always': 'sempre',
        'FPS limit': 'Limite de FPS',
        'unlimited': 'sem limite',
        'Theme': 'Tema',
        // palavras curtas que faltavam (OG-068/069/085)
        'guest': 'convidado',
        'players': 'jogadores',
        // OG-066: telas F1–F5
        'Ping': 'Ping',
        'Capt': 'Capt',
        'dropped': 'largadas',
        'returned': 'devolvidas',
        'Taken': 'Recebidos',
        'Speed': 'Velocidade',
        'Playtime': 'Tempo de jogo',
        'Average lifetime': 'Vida média',
        'rank': 'posição',
        'power': 'força',
        'Nr': 'Nº',
        'Vote': 'Voto',
        // design system v2 (OG-200)
        Close: 'Fechar',
        // moldura e tela inicial (OG-201)
        'Main navigation': 'Navegação principal',
        'Main menu': 'Menu principal',
        Legal: 'Informações legais',
        'Capture the flag with friends, right in the browser.': 'Capture a bandeira com os amigos, direto no navegador.',
        'Open rooms, Casual and Ranked': 'Salas abertas, Casual e Ranqueado',
        'Play with friends using an invite link': 'Jogue com os amigos por um link de convite',
        'Season leaderboard': 'Classificação da temporada',
        'Watch recorded matches': 'Assista a partidas gravadas',
        'Your recent matches': 'Suas últimas partidas',
        Profile: 'Perfil',
        // opções e conta (OG-202)
        Game: 'Jogo',
        Graphics: 'Gráficos',
        Audio: 'Áudio',
        Language: 'Idioma',
        'Sound effects': 'Efeitos sonoros',
        'Add key': 'Adicionar tecla',
        'Press a key...': 'Pressione uma tecla...',
        Default: 'Padrão',
        permanent: 'definitivo',
        // trilha sonora (OG-222)
        Soundtrack: 'Trilha sonora',
        'Play the soundtrack': 'Tocar a trilha sonora',
        'Music volume': 'Volume da música',
        'The main theme opens the menus; then all tracks rotate. In Casual matches, every track but the theme, shuffled.': 'O tema principal abre os menus; depois todas as faixas se revezam. Nas partidas casuais, todas menos o tema, em ordem aleatória.',
        'The soundtrack is off.': 'A trilha sonora está desligada.',
        'Press play or any key to start the music.': 'Aperte o play ou qualquer tecla para começar a música.',
        'Turn on': 'Ligar',
        'Play music': 'Tocar música',
        'Pause music': 'Pausar música',
        'Next track': 'Próxima faixa',
        'Mute music': 'Silenciar música',
        'Unmute music': 'Tirar do mudo',
        // Jogar no computador (OG-323 a OG-326)
        'Play on your computer': 'Jogar no computador',
        'Install Outgun or download it for Windows, macOS or Ubuntu': 'Instale o Outgun ou baixe para Windows, macOS ou Ubuntu',
        'You are already playing in the Outgun app for your computer.': 'Você já está jogando no app do Outgun para computador.',
        'You are already playing in the installed Outgun app.': 'Você já está jogando no app instalado do Outgun.',
        'Outgun runs in the browser, but you can also open it from an icon on your computer, in its own window. It is the same game and always the same version as the site: nothing to update.': 'O Outgun roda no navegador, mas você também pode abri-lo por um ícone no computador, numa janela própria. É o mesmo jogo e sempre a mesma versão do site: não há nada para atualizar.',
        'Download the app': 'Baixar o app',
        'The game itself still comes from the site, so the app is always up to date.': 'O jogo em si continua vindo do site, então o app está sempre atualizado.',
        'Your system': 'Seu sistema',
        'Download $1': 'Baixar $1',
        'Windows 10 and 11, 64 bits. About 110 MB.': 'Windows 10 e 11, 64 bits. Cerca de 110 MB.',
        'No digital signature yet: if Windows shows "Windows protected your PC", click "More info" and then "Run anyway".': 'Ainda sem assinatura digital: se o Windows mostrar "O Windows protegeu o computador", clique em "Mais informações" e depois em "Executar assim mesmo".',
        'Apple Silicon and Intel, macOS 12 or newer. About 230 MB.': 'Apple Silicon e Intel, macOS 12 ou mais novo. Cerca de 230 MB.',
        'Open the .dmg and drag Outgun to Applications. The first time, the Mac blocks the app because it does not come from the App Store: go to System Settings > Privacy & Security and click "Open Anyway".': 'Abra o .dmg e arraste o Outgun para Aplicativos. Na primeira vez, o Mac bloqueia o app porque ele não vem da App Store: vá em Ajustes do Sistema > Privacidade e Segurança e clique em "Abrir mesmo assim".',
        'Ubuntu 22.04 or newer (and Debian-based systems), 64 bits. About 110 MB.': 'Ubuntu 22.04 ou mais novo (e sistemas baseados no Debian), 64 bits. Cerca de 110 MB.',
        'Open the .deb to install it from the App Center, or run: sudo apt install ./Outgun-linux.deb': 'Abra o .deb para instalar pela Central de Aplicativos, ou rode: sudo apt install ./Outgun-linux.deb',
        'Or install from the browser': 'Ou instale pelo navegador',
        'In Chrome or Edge: no download, a desktop shortcut and its own window. Takes a few seconds.': 'No Chrome ou no Edge: sem baixar nada, com atalho na área de trabalho e janela própria. Leva poucos segundos.',
        'Installed. Open Outgun from the icon on your computer.': 'Instalado. Abra o Outgun pelo ícone no computador.',
        'Install Outgun': 'Instalar o Outgun',
        'If no button appears here, open the browser menu and choose "Install Outgun" (Chrome: the icon at the right of the address bar). Firefox and Safari do not install sites.': 'Se nenhum botão aparecer aqui, abra o menu do navegador e escolha "Instalar Outgun" (no Chrome, o ícone à direita da barra de endereço). O Firefox e o Safari não instalam sites.',
        'No matches yet. "Play now" starts one.': 'Nenhuma partida ainda. "Jogar agora" começa uma.',
        // telas restantes no visual v2 (OG-203)
        'A .ogr file saved on this computer': 'Um arquivo .ogr salvo neste computador',
        'Every match has a "Watch" link': 'Cada partida tem o link "Assistir"',
        'Search rooms': 'Buscar salas',
        'Room or map': 'Sala ou mapa',
        'Hide full rooms': 'Esconder salas lotadas',
        Full: 'Lotada',
        // privacidade do perfil social (OG-211)
        'Profile privacy': 'Privacidade do perfil',
        'Hide my teammates and rivals': 'Esconder meus companheiros e rivais',
        'You also stop appearing in the lists of other players.': 'Você também deixa de aparecer nas listas dos outros jogadores.',
        'Hide my match history': 'Esconder meu histórico de partidas',
        // relatório de partida (OG-214)
        'Match report': 'Relatório da partida',
        'View match report': 'Ver relatório',
        'Red team wins': 'Vitória do time vermelho',
        'Blue team wins': 'Vitória do time azul',
        'Best player': 'Melhor jogador',
        'Watch replay': 'Assistir ao replay',
        'Detailed statistics': 'Estatísticas detalhadas',
        'No captures.': 'Nenhuma captura.',
        'Waiting for the match report...': 'Aguardando o relatório da partida...',
        'The report is not ready yet.': 'O relatório ainda não está pronto.',
        // perfil social, marcos e diretório (OG-212, OG-213, OG-215)
        'Member since $1': 'Membro desde $1',
        'last match $1': 'última partida $1',
        '#$1 of $2 in $3': '$1º de $2 na $3',
        'This player keeps it private.': 'Este jogador deixou isto privado.',
        Activity: 'Atividade',
        '7 days': '7 dias',
        '30 days': '30 dias',
        'No ranked matches this season.': 'Nenhuma partida ranqueada nesta temporada.',
        'Rating from $1 to $2 (lowest $3, highest $4)': 'Rating de $1 a $2 (mínimo $3, máximo $4)',
        Milestones: 'Marcos',
        Locked: 'Bloqueado',
        // marcos por grupo, raridade e secretos (OG-393)
        Progress: 'Progresso',
        Flag: 'Bandeira',
        Defense: 'Defesa',
        Combat: 'Combate',
        Social: 'Social',
        Humor: 'Humor',
        Secrets: 'Secretos',
        'Secret milestone': 'Marco secreto',
        '$1% of players': '$1% dos jogadores',
        '1 secret left to discover': '1 segredo a descobrir',
        '$1 secrets left to discover': '$1 segredos a descobrir',
        'Discovered first by $1': 'Descoberto primeiro por $1',
        'New milestone: $1': 'Marco novo: $1',
        'New milestones: $1': 'Marcos novos: $1',
        'Secret milestone unlocked! $1': 'Marco secreto desbloqueado! $1',
        'Recent matches': 'Partidas recentes',
        Teammates: 'Companheiros',
        Rivals: 'Rivais',
        Clan: 'Clã',
        Clans: 'Clãs',
        'Nobody yet.': 'Ninguém ainda.',
        'Nobody found.': 'Ninguém encontrado.',
        'Search by name or clan': 'Buscar por nome ou clã',
        '$1 players found': '$1 jogadores encontrados',
        'Most active this week': 'Mais ativos da semana',
        Members: 'Membros',
        'Active this week': 'Ativos na semana',
        'Find players and clans': 'Encontre jogadores e clãs',
        'Statistics, milestones and matches': 'Estatísticas, marcos e partidas',
        // leaderboard de atributos (OG-353)
        'Leaderboard': 'Leaderboard',
        'This month': 'Este mês',
        'All time': 'Sempre',
        'Stat': 'Estatística',
        'Overview': 'Visão geral',
        'See all': 'Ver todos',
        'Nobody with $1 matches yet.': 'Ninguém com $1 partidas ainda.',
        'You: $1º of $2 ($3)': 'Você: $1º de $2 ($3)',
        'You need $1 Ranked matches in the period to appear.': 'Você precisa de $1 partidas Ranqueadas no período para aparecer.',
        'One ranking for each stat, restarting every month. Only Ranked matches count; at least 5 matches in the period to appear.': 'Um ranking para cada estatística, que recomeça todo mês. Só partidas Ranqueadas contam; são precisas 5 partidas no período para aparecer.',
        'Per 10 minutes: totals divided by the time played, so whoever plays less can compete. Raw damage is hits on enemies × 70 and includes overkill.': 'Por 10 minutos: o total dividido pelo tempo jogado, para quem joga menos também poder competir. O dano bruto é acertos em inimigos × 70 e inclui o excesso.',
        'Flag carrying time': 'Tempo com bandeira',
        'Raw damage': 'Dano bruto',
        'Effective damage': 'Dano efetivo',
        'Kills in the enemy base': 'Abates na base inimiga',
        'Kills in your base': 'Abates na própria base',
        'Kills in midfield': 'Abates no meio',
        'Defenses': 'Defesas',
        'since $1': 'desde $1',
        'Multi-kills': 'Multi-kills',
        'Trades': 'Trocas',
        'First kills': 'Primeiros abates',
        'Kills by victim': 'Abates por vítima',
        Highlights: 'Destaques',
        'Kills by zone': 'Abates por zona',
        'Kills by zone: enemy base · midfield · own base.': 'Abates por zona: base inimiga · meio · própria base.',
        'No data for this match.': 'Sem dados nesta partida.',
        'Row = killer, column = victim.': 'Linha = quem matou, coluna = vítima.',
        'Who killed whom': 'Quem matou quem',
        'Send a map .txt in the Outgun format. Once published it can go into the rotations and private rooms, without a new release.': 'Envie um mapa .txt no formato do Outgun. Publicado, ele pode entrar nas rotações e nas salas privadas, sem esperar uma versão nova.',
        'Map published (version $1).': 'Mapa publicado (versão $1).',
        'Map deactivated.': 'Mapa desativado.',
        'Map file (.txt)': 'Arquivo do mapa (.txt)',
        'Check': 'Conferir',
        'Publish map': 'Publicar mapa',
        '$1 by $2, $3×$4 rooms.': '$1, de $2, $3×$4 salas.',
        'Deactivate': 'Desativar',
        'inactive': 'inativo',
        'Author': 'Autor',
        'Size': 'Tamanho',
        'Title': 'Título',
        'Favourite victims': 'Vítimas favoritas',
        'Who kills you most': 'Quem mais te mata',
        'No data yet (counted from Ranked matches since the event log).': 'Sem dados ainda (conta as ranqueadas desde o registro de eventos).',
        'Effective damage leaves out overkill. Base = the room where a team flag starts; defenses = kills next to an ally carrier or your own flag. Multi-kill = 2 or more kills up to 4 s apart; trade = killing, within 3 s, the enemy who just killed an ally; first kill = the first of the match and after each capture. These stats count from the date shown.': 'O dano efetivo não conta o excesso. Base = a sala onde nasce uma bandeira do time; defesas = abates perto de um portador aliado ou da sua bandeira. Multi-kill = 2 ou mais abates com até 4 s entre eles; troca = matar, em até 3 s, o inimigo que acabou de matar um aliado; primeiro abate = o primeiro da partida e depois de cada captura. Estes stats contam a partir da data indicada.',
        'Kills (enemy base)': 'Abates (base inimiga)',
        'Kills (own base)': 'Abates (própria base)',
        'Kills (midfield)': 'Abates (meio)',
        'Best kill streak': 'Maior sequência de abates',
        'per 10 minutes played': 'por 10 minutos jogados',
        'in the period': 'no período',
        'best match in the period': 'melhor partida no período',
        'average in the period': 'média no período',
        'Leaderboard: $1': 'Leaderboard: $1',
        'Full leaderboard': 'Leaderboard completo',
        'Leaders of the month': 'Líderes do mês',
        'Nobody in the leaderboard yet. Be the first: play Ranked.': 'Ninguém no leaderboard ainda. Seja o primeiro: jogue Ranqueado.',
        'Your rating: $1 (calibrating)': 'Seu rating: $1 (em calibração)',
        'Your rating: $1': 'Seu rating: $1',
        'Play Ranked to get your rating.': 'Jogue Ranqueado para ganhar o seu rating.',
        // hall da fama pelo leaderboard (OG-354)
        'The top 3 of every month in each main stat of the leaderboard and among clans.': 'Os 3 primeiros de cada mês em cada estatística principal do leaderboard e entre os clãs.',
        'classic ranking': 'ranking clássico',
        'in $1': 'em $1',
        // lista geral do mês (OG-358)
        'Overall of the month': 'Geral do mês',
        'index from 0 to 100': 'índice de 0 a 100',
        'Best of the month': 'Melhor do mês',
        'Each stat counts by your place among everyone with $1 matches (1st = all its weight, last = none). Weights: $2.': 'Cada estatística conta pela sua posição entre todos com $1 partidas (1º lugar = o peso inteiro, último = nada). Pesos: $2.',
        'Index': 'Índice',
        '$1 overall of the month': '$1 no geral do mês',
        // link da Steam na página de download (OG-359)
        'Also on Steam': 'Também na Steam',
        'Outgun is on Steam too: install it from the store and Steam keeps it updated.': 'O Outgun também está na Steam: instale pela loja e a Steam mantém o jogo atualizado.',
        'Open Outgun on Steam': 'Abrir o Outgun na Steam',
        // notificações (OG-361)
        '$1 invited you to the clan $2': '$1 convidou você para o clã $2',
        '$1 asked to join $2': '$1 pediu para entrar em $2',
        'Notifications ($1 unread)': 'Notificações ($1 não lidas)',
        'Notifications': 'Notificações',
        'Mark all as read': 'Marcar todas como lidas',
        'No notifications.': 'Nenhuma notificação.',
        // tela inicial nova (cartão de entrada, "Como jogar", rodapé)
        Guest: 'Convidado',
        'How to enter': 'Como entrar',
        'Choose a colour and a nickname': 'Escolha uma cor e um apelido',
        'Another colour': 'Outra cor',
        'Switch team': 'Trocar de time',
        Move: 'Mover',
        'Walk around the map with the arrow keys.': 'Ande pelo mapa com as setas.',
        'Fire rockets at the other team.': 'Atire foguetes no outro time.',
        'Run and strafe': 'Correr e andar de lado',
        'Hold one to run; hold the other to keep aiming while you move.': 'Segure uma para correr; segure a outra para manter a mira enquanto anda.',
        'Power-ups': 'Power-ups',
        'Shield, turbo, power, shadow and the deathbringer: pick them up on the map.': 'Escudo, turbo, força, sombra e o deathbringer: pegue pelo mapa.',
        'Need help?': 'Precisa de ajuda?',
        'Press it during a match to see every key.': 'Aperte durante a partida para ver todas as teclas.',
        Previous: 'Anterior',
        Next: 'Próximo',
        'Outgun on social media': 'Outgun nas redes sociais',
        'Also on the web': 'Também na web',
        'Find a clan': 'Procurar um clã',
        '$1º of $2': '$1º de $2',
        'play $1 Ranked': 'jogue $1 ranqueadas',
        'Follow Outgun on Instagram: news, clips and behind the scenes.': 'Siga o Outgun no Instagram: novidades, clipes e bastidores.',
        Follow: 'Seguir',
        'Join the WhatsApp group and set up matches with everyone.': 'Entre no grupo do WhatsApp e combine partidas com a galera.',
        'Join the group': 'Entrar no grupo',
        'Join our Discord: find a team, chat and follow the news.': 'Entre no nosso Discord: ache time, converse e acompanhe as novidades.',
        'Join the server': 'Entrar no servidor',
        'Open Outgun on the web': 'Abrir o Outgun na web',
        // falas do balão do boneco na tela inicial
        "Let's go!": 'Vamos lá!',
        "I'm ready!": 'Estou pronto!',
        'Off to get the flag!': 'Partiu bandeira!',
        'Pick me for your team!': 'Me chama pro time!',
        "Where's their flag?": 'Cadê a bandeira deles?',
        "I'm capturing today!": 'Hoje eu capturo!',
        'That flag is mine!': 'Essa bandeira é minha!',
        'Come and get it!': 'Vem que tem!',
        'Aim at me, if you can!': 'Mira em mim, se for capaz!',
        'My gun is warmed up.': 'Já aqueci o canhão.',
        'Hold Alt and keep up!': 'Segura Alt e me acompanha!',
        'Shift to run, remember!': 'Shift pra correr, hein!',
        'Grab a power-up on the way!': 'Pega um power-up no caminho!',
        // celular de volta, sem a partida (S45, D-80)
        'This part of Outgun is not available on phones yet.': 'Esta parte do Outgun ainda não está disponível para celular.',
        'Back to the start': 'Voltar ao início',
        Menu: 'Menu',
        'Casual matches work here with touch controls (experimental); Ranked and the OutCup are played on a computer. Here you also follow stats, profiles, clans and match reports.': 'Aqui dá para jogar o Casual com controles de toque (experimental); Ranked e OutCup, só no computador. Você também acompanha estatísticas, perfis, clãs e relatórios das partidas.',
        'Sign in to see your profile, your clan and your matches.': 'Entre para ver seu perfil, seu clã e suas partidas.',
        'My last matches': 'Minhas últimas partidas',
        'Nobody is playing right now.': 'Ninguém está jogando agora.',
        // PDF do relatório (OG-425, OG-426)
        'Download PDF': 'Baixar PDF',
        'Creating the PDF...': 'Gerando o PDF...',
        'Could not create the PDF.': 'Não foi possível gerar o PDF.',
        Duration: 'Duração',
        'Game version': 'Versão do jogo',
        'Page $1 of $2': 'Página $1 de $2',
        'Maps, presets, rotations, bots, roles, invites and network: only on the computer.': 'Mapas, presets, rotações, bots, papéis, convites e rede: só no computador.',
        'Match / HUD': 'Partida / HUD',
        'Lobby and rooms': 'Lobby e salas',
        'Ranked and series': 'Ranqueado e séries',
        'Portal (home, profile, ranking, hall of fame)': 'Portal (início, perfil, ranking, hall da fama)',
        'Match report / PDF': 'Relatório / PDF',
        'Replay / spectator': 'Replay / espectador',
        'Account and sign in': 'Conta e login',
        'Moderation / admin': 'Moderação / admin',
        'Steam / desktop app': 'Steam / app para computador',
        'Server / connection': 'Servidor / conexão',
        Always: 'Sempre',
        Sometimes: 'Às vezes',
        'It happened once': 'Aconteceu uma vez',
        'Critical: brings down the match or the server, loses data or account, security flaw': 'Crítico: derruba a partida ou o servidor, perde dados ou conta, falha de segurança',
        'High: keeps me from playing or using a screen, no workaround': 'Alto: impede de jogar ou de usar uma tela, sem contorno',
        'Medium: gets in the way, but there is a workaround': 'Médio: atrapalha, mas tem contorno',
        'Low: visual, text, detail': 'Baixo: visual, texto, detalhe',
        'Fill in the summary and what happened.': 'Preencha o resumo e o que aconteceu.',
        'Where did it happen?': 'Onde aconteceu?',
        'Summary (what is wrong, in one sentence)': 'Resumo (o que está errado, em uma frase)',
        'Steps to reproduce': 'Passos para reproduzir',
        'One step per line.': 'Um passo por linha.',
        'What I expected': 'O que eu esperava',
        'What happened': 'O que aconteceu',
        'How often?': 'Com que frequência?',
        Severity: 'Gravidade',
        'Evidence (links to the match, screenshots, videos)': 'Evidências (links da partida, prints, vídeos)',
        'Your last match, the game version, your browser and the time go along automatically.': 'Sua última partida, a versão do jogo, o navegador e a hora vão junto automaticamente.',
        'Known workaround': 'Contorno conhecido',
        'Attach image': 'Anexar imagem',
        'Recovering the video...': 'Recuperando o vídeo...',
        'The video did not come back. Reload the game to return to the match.': 'O vídeo não voltou. Recarregue o jogo para voltar à partida.',
        Reload: 'Recarregar',
        'Or paste a screenshot (Ctrl+V) in the field above.': 'Ou cole um print (Ctrl+V) no campo acima.',
        'Up to $1 images.': 'No máximo $1 imagens.',
        'Too many images for now; try again later.': 'Imagens demais por agora; tente mais tarde.',
        'Could not attach the image.': 'Não foi possível anexar a imagem.',
        'Image $1': 'Imagem $1',
        'Remove image $1': 'Remover a imagem $1',
        'Sending image...': 'Enviando a imagem...',
        Issue: 'Issue',
        'Open issue': 'Abrir issue',
        'Open issue on GitHub': 'Abrir issue no GitHub',
        'Issue #$1 opened on GitHub.': 'Issue #$1 aberta no GitHub.',
        'Labels: $1. The repository is public: everyone will see this text.': 'Labels: $1. O repositório é público: todos verão este texto.',
        'Fixed in $1': 'Corrigido na $1',
        Fixed: 'Corrigido',
        'Will not be fixed': 'Não será corrigido',
        Resolved: 'Resolvido',
        'In the fix queue': 'Na fila de correção',
        Received: 'Recebido',
        Confirmed: 'Confirmado',
        'Your reports': 'Seus relatos',
        'Send test error': 'Enviar erro de teste',
        'Test error sent to the error service.': 'Erro de teste enviado ao serviço de erros.',
        // Radar de estilo (OG-469 a OG-479)
        'Killing': 'Abates',
        'Survival': 'Sobrevivência',
        'Teamwork': 'Equipe',
        'Shooter': 'Atirador',
        'Runner': 'Corredor',
        'Support': 'Suporte',
        'Survivor': 'Sobrevivente',
        'Joker': 'Coringa',
        'No data': 'Sem dados',
        'Axis': 'Eixo',
        'See radar': 'Ver radar',
        'See as table': 'Ver em tabela',
        'Percentile $1': 'Percentil $1',
        '$1 Ranked matches': '$1 ranqueadas',
        'Few matches': 'Poucos jogos',
        'How to read the radar': 'Como ler o radar',
        'Each axis is a percentile against everyone active in the period: 50 is the median, 90 means better than 90% of them. The area is not a grade: it shows a style. Percentiles change as other people play.': 'Cada eixo é um percentil contra todos os ativos do período: 50 é a mediana, 90 quer dizer melhor que 90% deles. A área não é nota: mostra um estilo. O percentil muda conforme os outros jogam.',
        'Play style': 'Estilo de jogo',
        'Play style of $1': 'Estilo de jogo de $1',
        'Play $1 more Ranked matches in the period to see the radar.': 'Jogue mais $1 ranqueadas no período para ver o radar.',
        'Change since $1': 'Mudança desde $1',
        'No previous season to compare yet.': 'Ainda não há temporada anterior para comparar.',
        '$1 counts since $2': '$1 conta desde $2',
        'Compare with': 'Comparar com',
        'Player name': 'Nome do jogador',
        'Compare': 'Comparar',
        'Compare with me': 'Comparar comigo',
        'Stop comparing': 'Parar de comparar',
        'Player $1 not found.': 'Jogador $1 não encontrado.',
        '$1 has no radar yet: $2 of $3 Ranked matches in the period.': '$1 ainda não tem radar: $2 de $3 ranqueadas no período.',
        '$1 vs $2': '$1 x $2',
        'Even: $1 axes each': 'Empate: $1 eixos para cada',
        '$1 leads $2 of 6 axes': '$1 leva $2 de 6 eixos',
        'Advantage': 'Vantagem',
        'Even': 'Empate',
        '$1 by $2': '$1 por $2',
        'All maps': 'Todos os mapas',
        'Few matches on this map in the period to compare.': 'Poucos jogos neste mapa no período para comparar.',
        'Share style': 'Compartilhar estilo',
        'Reference': 'Referência',
        'Median of $1': 'Mediana do $1',
        'Median of the top 10': 'Mediana do top 10',
        'This match': 'Esta partida',
        'Play style in this match': 'Estilo de jogo nesta partida',
        'match too short': 'partida curta demais',
        'Percentile of the match against everyone active in the season; the season percentile in parentheses.': 'Percentil da partida contra todos os ativos da temporada; entre parênteses, o percentil da temporada.',
        'Match too short for a radar (under $1 min played).': 'Partida curta demais para o radar (menos de $1 min jogados).',
        'Solid: this match against everyone active in the season. Dashed: the player in the season.': 'Contorno cheio: esta partida contra todos os ativos da temporada. Tracejado: o jogador na temporada.',
        'No radar yet on either side': 'Nenhum dos lados tem radar ainda',
        'median of $1 players': 'mediana de $1 jogadores',
        'no radar yet': 'sem radar ainda',
        'Matchup preview': 'Prévia do confronto',
        'Median of the lined-up players, only Ranked matches played for the clan this season.': 'Mediana de quem está escalado, só com as ranqueadas jogadas pelo clã nesta temporada.',
        'Against $1': 'Contra $1',
        'Rival': 'Rival',
        'None': 'Nenhum',
        'Us against them': 'Nós contra eles',
        'Us x them': 'Nós x eles',
        '$1 matches against $2.': '$1 partidas contra $2.',
        'Not enough matches against $1 for a radar yet.': 'Ainda não há partidas suficientes contra $1 para um radar.',
        'Strong point: $1': 'Ponto forte: $1',
        'Weak point: $1': 'Ponto fraco: $1',
        'Median of $1 members': 'Mediana de $1 membros',
        'No member has 3 Ranked matches for the clan in the period yet.': 'Nenhum membro tem ainda 3 ranqueadas pelo clã no período.',
        'Only Ranked matches played for the clan count; members need 3 of them to enter the median.': 'Só contam as ranqueadas jogadas pelo clã; o membro precisa de 3 delas para entrar na mediana.',
        'Final': 'Final',
        'Semi-finals': 'Semifinal',
        'Quarter-finals': 'Quartas de final',
        'Round of 16': 'Oitavas de final',
        'Round of 32': '16 avos de final',
        'Round $1': 'Fase $1',
        'Waiting for the previous round': 'Aguardando a fase anterior',
        'Time proposed: $1': 'Horário proposto: $1',
        'Waiting for a time': 'Aguardando horário',
        'Scheduled: $1': 'Marcado: $1',
        'Room open': 'Sala aberta',
        'Decided by the admin': 'Decidido pelo admin',
        'Played (tiebreak by captures)': 'Jogado (desempate por capturas)',
        'Played': 'Jogado',
        'Walkover': 'W.O.',
        'Both out by walkover': 'As duas fora por W.O.',
        'Bye': 'Passa direto',
        'With the admin': 'Com o admin',
        'You are signed up. The pairs are drawn when sign-ups close.': 'Inscrição feita. As duplas são sorteadas quando as inscrições fecharem.',
        'You left this edition.': 'Você saiu desta edição.',
        'Banned accounts cannot sign up.': 'Contas banidas não podem se inscrever.',
        'Sign-ups are closed.': 'As inscrições estão fechadas.',
        'Could not save. Try again.': 'Não foi possível salvar. Tente de novo.',
        'The monthly 2v2 cup: sign up alone, play with a drawn partner, knockout until the title.': 'A copa mensal 2x2: inscreva-se sozinho, jogue com a dupla sorteada, mata-mata até o título.',
        'No OutCup edition yet. Sign-ups open on the 20th of each month.': 'Ainda não há edição da OutCup. As inscrições abrem no dia 20 de cada mês.',
        'Sign-ups': 'Inscrições',
        'Sign-ups close on $1, when the game draws the pairs at random. Games start on $2; each round has a window of about a week and the final ends by the last day of the month.': 'As inscrições fecham em $1, quando o jogo sorteia as duplas. Os jogos começam em $2; cada fase tem uma janela de cerca de uma semana e a final termina até o último dia do mês.',
        '$1 signed up. The cup needs at least 8 (4 pairs).': '$1 inscritos. A copa precisa de pelo menos 8 (4 duplas).',
        'Leave this edition': 'Sair desta edição',
        'Sign me up': 'Inscrever-me',
        'Sign-ups open on $1.': 'As inscrições abrem em $1.',
        'Sign in to take part.': 'Entre na sua conta para participar.',
        'Edition cancelled': 'Edição cancelada',
        'This edition did not reach the minimum of 4 pairs (8 sign-ups).': 'Esta edição não teve o mínimo de 4 duplas (8 inscritos).',
        'Sign-ups open': 'Inscrições abertas',
        'In progress': 'Em andamento',
        'Finished': 'Encerrada',
        'Cancelled': 'Cancelada',
        '$1 pairs': '$1 duplas',
        'Champions': 'Campeões',
        'You were left out of the draw this time (odd number of sign-ups).': 'Desta vez você ficou de fora do sorteio (número ímpar de inscritos).',
        'My pair': 'Minha dupla',
        'seed $1': 'cabeça de chave $1',
        'Next match: against $1 ($2).': 'Próximo confronto: contra $1 ($2).',
        'Open the match': 'Abrir o confronto',
        'Your run in this edition is over. Thanks for playing!': 'Sua campanha nesta edição terminou. Obrigado por jogar!',
        'Your next opponent comes from the match above in the bracket.': 'O próximo adversário sai do confronto anterior na chave.',
        'Calendar': 'Calendário',
        'best of $1': 'melhor de $1',
        'Bracket': 'Chave',
        'skips the round': 'passa direto',
        'to be decided': 'a definir',
        'All four players must have marked this hour.': 'Os quatro jogadores precisam ter marcado esta hora.',
        'Pick a whole hour inside the round window, at least 30 minutes ahead.': 'Escolha uma hora cheia dentro da janela da fase, com pelo menos 30 minutos de antecedência.',
        'Hours must be inside the round window.': 'As horas precisam estar dentro da janela da fase.',
        'The room is not on air yet.': 'A sala ainda não está no ar.',
        'Window: $1 to $2': 'Janela: $1 a $2',
        'Join the room': 'Entrar na sala',
        'The room opens 15 minutes before. A pair that is not complete 15 minutes after the start loses by walkover.': 'A sala abre 15 minutos antes. A dupla que não estiver completa 15 minutos depois do horário perde por W.O.',
        'The other pair proposed $1.': 'A outra dupla propôs $1.',
        'Match scheduled.': 'Jogo marcado.',
        'Proposal declined.': 'Proposta recusada.',
        'Your pair proposed $1. Waiting for the other pair.': 'Sua dupla propôs $1. Aguardando a outra dupla.',
        'Hours saved.': 'Horários salvos.',
        'Time proposed to the other pair.': 'Horário proposto à outra dupla.',
        'When can you play?': 'Quando você pode jogar?',
        'Click the hours you can play (your time zone: $1). The number shows how many of the other three can; a gold hour works for all four.': 'Clique nas horas em que você pode jogar (seu fuso: $1). O número mostra quantos dos outros três podem; uma hora dourada serve para os quatro.',
        '$1 of the other 3': '$1 dos outros 3',
        'Save my hours': 'Salvar meus horários',
        'Propose a time': 'Propor um horário',
        'No hour works for all four yet. Mark more hours or ask the others in the chat.': 'Nenhuma hora serve para os quatro ainda. Marque mais horas ou combine com os outros no chat.',
        'Past editions': 'Edições anteriores',
        '$1 signed up': '$1 inscritos',
        'OutCup champion': 'Campeão da OutCup',
        'OutCup runner-up': 'Vice da OutCup',
        'You are signed up. Draw on $1.': 'Você está inscrito. Sorteio em $1.',
        'Sign-ups open until $1.': 'Inscrições abertas até $1.',
        '$1 match(es) on air now.': '$1 confronto(s) no ar agora.',
        'Write the reason first (it goes to the audit log).': 'Escreva o motivo antes (ele vai para a auditoria).',
        'Every action needs a reason and goes to the audit log.': 'Toda ação pede um motivo e vai para a auditoria.',
        'Edition': 'Edição',
        'Open the cup page': 'Abrir a página da copa',
        'Open an edition now (YYYY-MM)': 'Abrir uma edição agora (AAAA-MM)',
        'Edition opened.': 'Edição aberta.',
        'Open': 'Abrir',
        'Dates saved.': 'Datas salvas.',
        'Edition cancelled.': 'Edição cancelada.',
        'Cancel this edition': 'Cancelar esta edição',
        'Matches in progress': 'Confrontos em andamento',
        'Walkovers and admin results': 'W.O. e resultados do admin',
        'Result undone.': 'Resultado desfeito.',
        'Undo': 'Desfazer',
        'Draw date': 'Sorteio',
        'Start': 'Início',
        'End': 'Fim',
        'Save dates': 'Salvar datas',
        'Result saved.': 'Resultado salvo.',
        'Both out': 'As duas fora',
        'New time': 'Novo horário',
        'Window ends': 'Fim da janela',
        'Match rescheduled.': 'Confronto remarcado.',
        'Reschedule': 'Remarcar',
        'Reopen for the pairs': 'Reabrir para as duplas',
        'Player out': 'Sai',
        'Player in': 'Entra',
        'Player replaced.': 'Jogador trocado.',
        'Replace': 'Trocar',
        'OutCup sign-ups are open.': 'As inscrições da OutCup estão abertas.',
        'OutCup: your pair skips the first round.': 'OutCup: sua dupla passa direto da primeira fase.',
        'OutCup: you play with $1 against $2.': 'OutCup: você joga com $1 contra $2.',
        'OutCup: your next opponent is $1.': 'OutCup: seu próximo adversário é $1.',
        'OutCup: you were left out of the draw (odd number of sign-ups).': 'OutCup: você ficou de fora do sorteio (número ímpar de inscritos).',
        'OutCup: this edition was cancelled.': 'OutCup: esta edição foi cancelada.',
        'OutCup: $1 proposed $2.': 'OutCup: $1 propôs $2.',
        'OutCup: $1 declined the proposed time.': 'OutCup: $1 recusou o horário proposto.',
        'OutCup: match against $1 scheduled for $2.': 'OutCup: confronto contra $1 marcado para $2.',
        'OutCup: the room for your match is open.': 'OutCup: a sala do seu confronto abriu.',
        'OutCup: the round window ends on $1 and your match is not scheduled.': 'OutCup: a janela da fase termina em $1 e seu confronto não foi marcado.',
        'OutCup: your pair moves on!': 'OutCup: sua dupla passou de fase!',
        'OutCup: both pairs are out by walkover.': 'OutCup: as duas duplas ficaram de fora por W.O.',
        'OutCup: $1 won the match.': 'OutCup: $1 venceu o confronto.',
        'OutCup: $1 won the cup!': 'OutCup: $1 venceu a copa!',
        'E-mails': 'E-mails',
        'OutCup e-mails': 'E-mails da OutCup',
        'Draw, scheduled matches, room open and results. The notices in the portal stay on.': 'Sorteio, jogos marcados, sala aberta e resultados. Os avisos no portal continuam.',
        '2v2 is here! To celebrate, sign up for the first OutCup.': 'Chegou o 2x2! Para comemorar, inscreva-se na primeira OutCup.',
    },
};
//# sourceMappingURL=web-texts.js.map